
export enum UserRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  STAF_ADMIN = 'STAF_ADMIN',
  STAF_HO = 'STAF_HO',
  STAF_FINANCE = 'STAF_FINANCE'
}

export enum ViewState {
  DASHBOARD = 'DASHBOARD',
  ADMIN_DASHBOARD = 'ADMIN_DASHBOARD', // Added for Super Admin
  ANALYTICS = 'ANALYTICS',
  COMPANIES = 'COMPANIES',
  COMPANY_MANAGER = 'COMPANY_MANAGER',
  USERS = 'USERS',
  USER_MANAGER = 'USER_MANAGER',
  RECORD_STATEMENT = 'RECORD_STATEMENT',
  RECORD_MUTUAL_FUND = 'RECORD_MUTUAL_FUND',
  STATEMENTS = 'STATEMENTS',
  RECONCILIATION = 'RECONCILIATION',
  INTEGRATIONS = 'INTEGRATIONS',
  WORKFLOWS = 'WORKFLOWS',
  REPORTS = 'REPORTS',
  AUDIT_LOGS = 'AUDIT_LOGS',
  SETTINGS = 'SETTINGS',
  HELP = 'HELP'
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  allowedCompanyIds?: string[]; // IDs of companies this user can access
}

export type AccountType = 'BANK' | 'INVESTMENT';

export interface BankAccount {
  id: string;
  bankName: string;
  accountNumber: string;
  accountName: string; // Legal name on account
  currency: string;
  swiftCode?: string;
  routingNumber?: string;
  status: 'active' | 'inactive';
  accountType: AccountType;
}

export interface Company {
  id: string;
  name: string;
  industry: string;
  status: 'active' | 'inactive';
  isHolding?: boolean;
  parentId?: string;
  bankAccounts?: BankAccount[];
  // Extended Details
  taxId?: string;
  incorporationDate?: string;
  contactEmail?: string;
  contactPhone?: string;
  address?: string;
  country?: string;
  logoUrl?: string;
  spreadsheetId?: string; // Legacy - Google Spreadsheet ID for syncing transactions
  statementSpreadsheetId?: string; // Google Spreadsheet ID for bank statements
  mutualFundSpreadsheetId?: string; // Google Spreadsheet ID for mutual funds
}

export interface Transaction {
  id: string;
  companyId: string;
  bankAccountId?: string;
  date: string;
  description: string;
  amount: number;
  units?: number;
  type: 'credit' | 'debit';
  status: 'pending' | 'reconciled' | 'flagged';
  imageUrl?: string;
}

export interface StatementData {
  date: string;
  description: string;
  amount: number;
  type: 'credit' | 'debit';
  bankAccountId?: string;
}
